import { css } from 'styled-components';
import {
  BreakpointQueryName, getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const searchAgency: ThemedFunctor = ({
  theme,
}) => css`
  background: ${theme.palettes.neutrals.lightest};
  border-radius: 6px;
  box-shadow: -1.25rem 1.25rem 1.25rem rgba(0,0,0,0.05);
  text-align: left;
  min-width: 30rem;

  ${theme.breakpoints.down(BreakpointQueryName.MD)} {
    min-width: 22rem;
  }
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.paddingBottom(theme, SpacingName.BIG)}
`;
